(function ($) {
  'use strict';

  /**
   * Footer Menu
   */

  var $footer_section_links = $('.navigation--footer > ul > li.menu-item-has-children > a:is( [href="#"], [href=""] )');

  // Convert top level links to fake headings
  $footer_section_links.each(function () {
    $(this).replaceWith( $( '<p role="heading" aria-level="2">' + this.innerHTML + '</p>' ) );
  });

})(jQuery);
